import React from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import BrandDocumentHead from './components/BrandDocumentHead';
import { BrandProvider } from './contexts/BrandContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AuthGuard from './pages/AuthGuard';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { QueryProvider } from './providers/QueryProvider';
import './App.css';

const App: React.FC = () => {
  return (
    <QueryProvider>
      <BrandProvider>
        <BrandDocumentHead />
        <ThemeProvider>
          <CssBaseline />
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/dashboard"
                  element={
                    <AuthGuard>
                      <Dashboard />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/"
                  element={
                    <AuthGuard>
                      <Navigate to="/dashboard" replace />
                    </AuthGuard>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </Router>
        </ThemeProvider>
      </BrandProvider>
    </QueryProvider>
  );
};

export default App;
